import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './rate.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Rate } from "model/system/rate.model";

export interface RateDetailsProps extends DetailsStateAndDispatchProps<Rate, 'CurrencyType'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const RateDetails: FC<RateDetailsProps> = (props) => {
  return (
    <DetailsPage<Rate, 'CurrencyType'>
      title={'汇率详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Rate, 'CurrencyType'>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ rate }: RootState) => ({
  entity: rate.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RateDetails);
